var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    { staticClass: "ad-event__form" },
    [
      _c("label", { staticClass: "mb-1" }, [
        _vm._v("ชื่อ Event สำหรับส่งไปให้ Facebook (ภาษาอังกฤษ) "),
        _c("span", { staticClass: "error--text" }, [_vm._v("*")]),
      ]),
      _c("v-text-field", {
        attrs: {
          value: "fb_mobile_purchase",
          disabled: "",
          outlined: "",
          dense: "",
        },
      }),
      _c("label", { staticClass: "mb-1" }, [
        _vm._v("มูลค่า Event "),
        _c("span", { staticClass: "error--text" }, [_vm._v("*")]),
      ]),
      _c("v-text-field", {
        attrs: { value: "ยอดขาย", disabled: "", outlined: "", dense: "" },
      }),
      _c("label", { staticClass: "mb-1" }, [
        _vm._v("สถานะออเดอร์ "),
        _c("span", { staticClass: "error--text" }, [_vm._v("*")]),
      ]),
      _c("v-text-field", {
        attrs: { value: "ทุกออเดอร์", disabled: "", outlined: "", dense: "" },
      }),
      _c("label", { staticClass: "mb-1" }, [
        _vm._v("สำหรับเพจ "),
        _c("span", { staticClass: "error--text" }, [_vm._v("*")]),
      ]),
      _c("AdEventPageSelect", {
        attrs: { value: _vm.page, items: _vm.pages, dense: "" },
        on: {
          input: function ($event) {
            return _vm.$emit("update:page", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }